import { Link } from 'react-router-dom';

export default function UsefulMaterials() {
  const items = [
    { icon: 'ri-book-open-line', title: 'Что такое корпоративное обучение сотрудников', desc: 'Полное руководство по системе обучения персонала: виды, методы, этапы внедрения и оценка эффективности', href: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie' },
    { icon: 'ri-line-chart-line', title: 'Обучение отдела продаж', desc: 'Развитие менеджеров по продажам: диагностика, практические тренинги и сопровождение для роста прибыли', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh' },
    { icon: 'ri-user-star-line', title: 'Тренинг для руководителей', desc: 'Развитие управленческих навыков: лидерство, делегирование, обратная связь и управление командой', href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley' },
    { icon: 'ri-team-line', title: 'Командообразование', desc: 'Формирование сплочённой команды через тренинги, бизнес-игры и командные мероприятия', href: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie' },
    { icon: 'ri-building-2-line', title: 'Корпоративная академия', desc: 'Построение системы корпоративного обучения для непрерывного развития сотрудников компании', href: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya' },
    { icon: 'ri-graduation-cap-line', title: 'Корпоративный университет', desc: 'Создание внутреннего образовательного центра для системного обучения всех уровней персонала', href: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Оценка эффективности обучения', desc: 'Методики оценки ROI корпоративного обучения: от реакции участников до бизнес-показателей', href: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya' },
    { icon: 'ri-user-3-line', title: 'Индивидуальные программы обучения', desc: 'Персональные траектории развития для руководителей и ключевых специалистов компании', href: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-3">
          Полезные материалы
        </h2>
        <p className="text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto">
          Эти материалы дополнят ваше понимание корпоративного обучения и помогут выбрать оптимальную программу
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => (
            <Link
              key={i}
              to={item.href}
              className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group text-center cursor-pointer"
            >
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm group-hover:text-teal-700 transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}